export default __webpack_public_path__ + "static/media/mum.e78c48ac.ogg";